const QUERY_REFERRER = `
  query WebReferrer($referral_code: String!) {
    referrer(referral_code: $referral_code) {
      customer_id
      referrer_avatar
      referrer_nickname
      salesman_in_cooperation_plan
      banner_group {
        id
        banners {
          image_url
          extra
        }
      }
    }
  }
`

const MUTATION_RECEIVE_REFERRAL = `
  mutation WebReceiveReferral($input: ReceiveReferralInput!) {
    ReceiveReferral(input: $input) {
        success
        can_purchase_with_referral_code
    }
  }
`

export default { QUERY_REFERRER, MUTATION_RECEIVE_REFERRAL }
